import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getMenuById } from "../../api/MenuService";
import { getErrorMessage } from "../../utils/errorHandler"
export default function MenuView() {
  const location = useLocation();
  const id = location.state?.menuId;
  const [menu, setMenu] = useState(null);
  const [loading, setLoading] = useState(false);
  const fetchMenu = async () => {
    setLoading(true);
    try {
      const res = await getMenuById(id);
      if (res?.data?.data) {
        setMenu(res.data.data);
      } else if (res?.data) {
        setMenu(res.data);
      } else {
        setMenu(null);
      }
    } catch (error) {
      console.error("Failed to fetch menu", error);
      alert(getErrorMessage(error));
      setMenu(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchMenu();
    }
  }, [id]);
  if (loading) {
    return (
      <div className="text-center mt-2">
        <h6>Loading...</h6>
      </div>
    );
  }
  if (!menu) {
    return (
      <div className="text-center mt-2">
        <h6>Menu Not Found</h6>
      </div>
    );
  }
  return (
    <div
    >
      <div
        className="conatiner-fluid p-4"
       
      >
        <div className="card p-3">
          <h5 className="fw-bold mb-3">
            Menu Details - {menu.name}
          </h5>
          {/* ROW 1 */}
          <div className="row mb-2">
            <div className="col-4 px-1">
              <strong>Slug:</strong> {menu.slug || "-"}
            </div>
            <div className="col-4 px-1">
              <strong>Type:</strong> {menu.type || "-"}
            </div>
            <div className="col-4 px-1">
              <strong>Visible:</strong> {menu.visible ? "Yes" : "No"}
            </div>
          </div>
          {/* ROW 2 */}
          <div className="row">
            <div className="col-4 px-1">
              <strong>Order:</strong> {menu.order ?? "-"}
            </div>
            <div className="col-4 px-1">
              <strong>Parent:</strong> {menu.parentId || "-"}
            </div>
            <div className="col-4 px-1">
              <strong>Status:</strong> {menu.status || "Inactive"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}